import { render } from "./AsSubscription.vue?vue&type=template&id=17049fe8&scoped=true&ts=true"
import script from "./AsSubscription.vue?vue&type=script&lang=ts"
export * from "./AsSubscription.vue?vue&type=script&lang=ts"

import "./AsSubscription.vue?vue&type=style&index=0&id=17049fe8&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17049fe8"]])

export default __exports__